export default __webpack_public_path__ + "static/media/roomRender.5f6f6c30.gltf";